import {
  DEFAULT_DATA_GRID_CLASS_NAME,
  ONBOARDING_DATA_GRID_CLASS_NAME,
  DEFAULT_FOOTER_HEIGHT,
} from '../../constants/data-grid';

const defaultFingoDataGrid = () => ({
  border: 'none',
  '& .MuiDataGrid-columnHeaders': {
    border: 'none',
  },
  '& .MuiDataGrid-row': {
    backgroundColor: '#f9f9f9',
    verticalAlign: 'top',
    marginBottom: 8,
    borderRadius: 12,
  },
  '& .MuiDataGrid-cell': {
    border: 'none',
    overflow: 'auto !important',
    whiteSpace: 'initial !important',
    '&:focus': {
      outline: 'none',
    },
    '&:focus-within': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-footerContainer': {
    justifyContent: 'center',
  },
  '& .MuiDataGrid-row--disabled .disabled-row-message': {
    display: 'none',
  },
  '& .MuiDataGrid-iconSeparator': {
    zIndex: -1,
  },
});

const onboardingFingoDataGrid = ({ theme }) => ({
  border: `1px solid ${theme.palette.gray.A200}`,
  borderRadius: 12,
  '& .MuiDataGrid-columnHeaders': {
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    backgroundColor: theme.palette.gray.A100,
    borderBottom: `1px solid ${theme.palette.gray.A400}`,
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: 'transparent',
      '&:focus': {
        outline: 'none',
      },
      '&:focus-within': {
        outline: 'none',
      },
    },
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    color: theme.palette.gray.A800,
    fontWeight: 'bold',
    fontSize: theme.typography.large_2.fontSize,
    '& .MuiTypography-root': {
      textWrap: 'auto',
      fontSize: theme.typography.small_2.fontSize,
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.small_1.fontSize,
      },
    },
  },
  '& .MuiDataGrid-cellCheckbox, & .MuiDataGrid-columnHeaderCheckbox': {
    '& .MuiCheckbox-root': {
      color: theme.palette.gray.A400,
      '&.Mui-checked': {
        color: theme.palette.primary.main,
      },
    },
  },
  '& .MuiDataGrid-columnHeaderCheckbox': {
    bottom: 2,
  },
  '& .MuiDataGrid-iconSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-row': {
    backgroundColor: 'white',
    verticalAlign: 'top',
    borderBottom: `1px solid ${theme.palette.gray.A300}`,
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.A100,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.A100,
    },
  },
  '& .MuiDataGrid-cell': {
    border: 'none',
    overflow: 'auto !important',
    whiteSpace: 'initial !important',
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 2,
      paddingRight: 2,
      overflow: 'hidden !important',
    },
    '& .MuiTypography-root, & .MuiDataGrid-cellContent': {
      fontSize: theme.typography.small_2.fontSize,
      fontWeight: 500,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.small_1.fontSize,
      },
    },
    '&:focus': {
      outline: 'none',
    },
    '&:focus-within': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-footerContainer': {
    justifyContent: 'right',
    height: DEFAULT_FOOTER_HEIGHT,
    minHeight: DEFAULT_FOOTER_HEIGHT,
    backgroundColor: 'white',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  '& .MuiDataGrid-selectedRowCount': {
    display: 'none',
  },
  '& .MuiDataGrid-row--disabled': {
    backgroundColor: 'white',
    color: theme.palette.gray.A400,
    opacity: 0.6,
    '& .MuiDataGrid-cellCheckbox': {
      opacity: 0,
    },
  },
  '& .no-padding-cell': {
    paddingLeft: 0,
    paddingRight: 0,
  },
  '& .no-padding-header': {
    paddingLeft: 0,
    paddingRight: 0,
  },
  '& .first-column-header': {
    marginLeft: 8,
  },
  '& .first-column-cell': {
    marginLeft: 8,
  },
  '& .last-column-header': {
    marginRight: 8,
  },
  '& .last-column-cell': {
    marginRight: 8,
  },
});
const MuiDataGrid = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_DATA_GRID_CLASS_NAME}`]: defaultFingoDataGrid({ theme }),
      [`&.${ONBOARDING_DATA_GRID_CLASS_NAME}`]: onboardingFingoDataGrid({ theme }),
    }),
  },
};

export default MuiDataGrid;
